import { pixelToIndex, pixelToAmplitude } from 'lib/lpt-charts/spectrumChart';
import {
  CreateSnapshotMarkerDto,
  CreateSnapshotMonitorDto,
  CreateSnapshotSpectralMaskDto,
  CreateSnapshotThresholdDto,
} from 'types';

import { CanvasPoint } from '../hooks/useDrawing';

export const formatMonitor = (
  ctx: CanvasRenderingContext2D | undefined | null,
  traceLength: number | undefined,
  reference: number,
  scale: number,
  startingPoint: CanvasPoint,
  endPoint: CanvasPoint
): CreateSnapshotMonitorDto | null => {
  if (!ctx || !traceLength) return null;

  return {
    name: 'New Monitor',
    begin: pixelToIndex(ctx, startingPoint.x, traceLength),
    end: pixelToIndex(ctx, endPoint.x, traceLength),
    upperbound: Math.round(
      pixelToAmplitude(startingPoint.y, ctx.canvas.height, reference, scale) *
        1000.0
    ),
    lowerbound: Math.round(
      pixelToAmplitude(endPoint.y, ctx.canvas.height, reference, scale) * 1000.0
    ),
  };
};

export const formatMarker = (
  ctx: CanvasRenderingContext2D | undefined | null,
  traceLength: number | undefined,
  endPoint: CanvasPoint,
  markerIndex: number
): CreateSnapshotMarkerDto | null => {
  if (!ctx || !traceLength) return null;

  return {
    index: markerIndex,
    x_pos: pixelToIndex(ctx, endPoint.x, traceLength),
  };
};

export const formatMask = (
  ctx: CanvasRenderingContext2D | undefined | null,
  traceLength: number | undefined,
  startingPoint: CanvasPoint,
  endPoint: CanvasPoint,
  bound: number
): CreateSnapshotSpectralMaskDto | null => {
  if (!ctx || !traceLength) return null;

  return {
    name: 'New Mask',
    begin: pixelToIndex(ctx, startingPoint.x, traceLength),
    end: pixelToIndex(ctx, endPoint.x, traceLength),
    upperbound: bound * 1000,
    lowerbound: bound * 1000,
  };
};

export const formatThreshold = (
  ctx: CanvasRenderingContext2D | undefined | null,
  traceLength: number | undefined,
  reference: number,
  scale: number,
  startingPoint: CanvasPoint,
  endPoint: CanvasPoint
): CreateSnapshotThresholdDto | null => {
  if (!ctx || !traceLength) return null;

  return {
    name: 'New Threshold',
    begin: pixelToIndex(ctx, startingPoint.x, traceLength),
    end: pixelToIndex(ctx, endPoint.x, traceLength),
    bound: Math.round(
      pixelToAmplitude(startingPoint.y, ctx.canvas.height, reference, scale) *
        1000.0
    ),
  };
};
